// components/client_servicing/Header.jsx
// Client Servicing Dashboard Header using StandardHeader

import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';

export const Header = ({ 
  loading, 
  lastUpdated,
  onRefresh,  // ✅ Accept onRefresh from parent
}) => {
  return (
    <StandardHeader
      title="Client Servicing"
      subtitle="Comprehensive analytics for servicing clients"
      loading={loading}
      lastUpdated={lastUpdated}
      onRefresh={onRefresh}  // ✅ Pass it directly to StandardHeader
      yearsOnly={false}
    />
  );
};